import { call, put, all, select, takeEvery } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { selectTablePageNumber } from 'modules/reportsTable/selectors';
import { deleteReport } from 'api/ReportingAPI';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { fetchFilteredReportTable } from '../reportsTable/actions';

export function* deleteReports({ deleteReportData }) {
  try {
    // this selector will return a new page number if we're on the
    // last page and we're deleting more reports than last page
    const page = yield select(selectTablePageNumber);
    const filters = { ...deleteReportData.filters, page };
    yield call(deleteReport, deleteReportData.ids);
    yield all([put(fetchFilteredReportTable(filters)), put(actions.closeDeleteReportModal())]);
    yield put(actions.deleteReportResponse(deleteReportData.reportName));
    if (deleteReportData.redirectOnComplete) {
      yield put(push('/reports/'));
    }
  } catch (error) {
    yield put(actions.deleteReportError(error, deleteReportData.reportName));
  }
}

addToRootSaga([takeEvery(actionTypes.DELETE_REPORTS_REQUEST, deleteReports)]);

export default { deleteReports };
